<template>
  <v-container>
    <v-row>
      <v-col col="12">
        <v-select
          :items="schoolYears"
          item-text="description"
          item-value="id"
          label="School Year"
          v-model="schoolYearSelected"
          return-object
        ></v-select>
      </v-col>
      <v-col col="12">
        <ReturnHomeBtn />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Exam Registrations
            <v-checkbox v-model="isHideFinalized" label="Hide Finalized Marks" class="mt-6 ml-2"></v-checkbox>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search Name"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-row>
            <v-col cols="12">
              <v-radio-group v-model="subjectId" label="Subject" row :mandatory="true" class="ml-4">
                <div v-for="s in subjectsRadio" :key="s.id">
                  <v-radio :label="s.description" :value="s.id"></v-radio>
                </div>
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <v-radio-group v-model="gradeLevel" label="Grade Level" row :mandatory="true" class="ml-4">
                <v-radio label="All grades" value="0"></v-radio>
                <v-radio label="1" value="1"></v-radio>
                <v-radio label="2" value="2"></v-radio>
                <v-radio label="3" value="3"></v-radio>
                <v-radio label="4" value="4"></v-radio>
                <v-radio label="5" value="5"></v-radio>
                <v-radio label="6" value="6"></v-radio>
                <v-radio label="7" value="7"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-data-table
            :loading="loading"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="exams"
            :server-items-length="examsTotal"
            :options.sync="options"
            :footer-props="{'items-per-page-options':[10, 20, 30]}"
            multi-sort
          >
            <template v-slot:top>
              <v-toolbar-title v-if="dialog">
                <ExamRegistrationDialog
                  v-bind:edited-item="editedItem"
                  v-bind:child-info="editedItem.student"
                  v-on:save="save"
                  v-on:close="close"
                />
              </v-toolbar-title>
            </template>

            <template v-slot:item.student.id="{ item }">
              <v-chip
                label
                outlined
                :color="item.student.color"
                class="font-weight-bold"
              >{{ item.student.id }}</v-chip>
            </template>

            <template v-slot:item.student.childFirstName="{ item }">
              <v-avatar :color="item.student.color" size="36">
                <span class="white--text">
                  <strong>{{ item.student.chipInitials }}</strong>
                </span>
              </v-avatar>
              <strong>&nbsp;&nbsp;{{ item.student.childFirstName }}</strong>
            </template>

            <template v-slot:item.student.childLastName="{ item }">
              <strong>{{ item.student.childLastName }}</strong>
            </template>

            <template v-slot:item.subjectId="{ item }">{{ getSubjectDescription(item.subjectId) }}</template>

            <template v-slot:item.createdDate="{ item }">{{ item.createdDate | formatDate }}</template>

            <template v-slot:item.examGradeType="{ item }">
              <v-chip
                :color="item.isFinal ? 'primary' : 'secondary'"
              >{{ examGradeType[item.examGradeType] }}</v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-layout :justify-end="true">
                <v-icon class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              </v-layout>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { errorMessageMixin, subjectMixin, examGradeTypeMixin } from "../shared";
import ReturnHomeBtn from "../components/ReturnHomeBtn.vue";
import ExamRegistrationDialog from "../components/ExamRegistrationDialog.vue";

export default {
  name: "Marks",
  mixins: [errorMessageMixin, subjectMixin, examGradeTypeMixin],
  components: { ReturnHomeBtn, ExamRegistrationDialog },
  async created() {
    await this.loadSchoolYears();
    if (this.schoolYear) {
      this.schoolYearSelected = this.schoolYear;
    } else {
      this.schoolYearSelected = this.schoolYears[0];
    }
    console.log("schoolYearSelected", this.schoolYearSelected);
    await this.loadExams(
      this.schoolYearSelected.id,
      this.isHideFinalized,
      this.subjectId,
      this.gradeLevel,
      this.search
    );
  },

  computed: {
    ...mapState([
      "exams",
      "examsTotal",
      "examGradeType",
      "subjects",
      "teachers",
      "schoolYears",
      "schoolYear"
    ]),
    subjectsRadio() {
      var result = [...this.subjects];
      result.unshift({ id: "0", description: "All subjects" });
      return result;
    }
  },
  watch: {
    schoolYearSelected: async function(val) {
      this.setSchoolYearAction(val);
      console.log("im in the watch for schoolYear", this.schoolYear);
      await this.loadExams(
        this.schoolYearSelected.id,
        this.isHideFinalized,
        this.subjectId,
        this.gradeLevel,
        this.search
      );
    },
    options: {
      async handler() {
        await this.loadExams(
          this.schoolYearSelected.id,
          this.isHideFinalized,
          this.subjectId,
          this.gradeLevel,
          this.search
        );
      },
      deep: true
    },
    isHideFinalized: async function() {
      console.log("in watch isHideFinalized", this.isHideFinalized);
      await this.loadExams(
        this.schoolYearSelected.id,
        this.isHideFinalized,
        this.subjectId,
        this.gradeLevel,
        this.search
      );
    },
    subjectId: async function() {
      console.log("in watch subjectId", this.subjectId);
      await this.loadExams(
        this.schoolYearSelected.id,
        this.isHideFinalized,
        this.subjectId,
        this.gradeLevel,
        this.search
      );
    },
    gradeLevel: async function() {
      console.log("in watch gradeLevel", this.gradeLevel);
      await this.loadExams(
        this.schoolYearSelected.id,
        this.isHideFinalized,
        this.subjectId,
        this.gradeLevel,
        this.search
      );
    },
    search: async function() {
      console.log("in watch search", this.search);
      await this.loadExams(
        this.schoolYearSelected.id,
        this.isHideFinalized,
        this.subjectId,
        this.gradeLevel,
        this.search
      );
    }
  },

  data() {
    return {
      search: "",
      options: {},
      loading: true,
      totalExams: 0,
      headers: [
        {
          text: "Child Id",
          value: "student.id",
          align: "start"
        },
        {
          text: "Child First Name",
          value: "student.childFirstName"
        },
        {
          text: "Child Last Name",
          value: "student.childLastName"
        },
        {
          text: "Subject",
          value: "subjectId"
        },
        {
          text: "Grade Level",
          value: "gradeLevel"
        },
        {
          text: "Created Date",
          value: "createdDate"
        },
        {
          text: "Exam Grade",
          value: "examGradeType"
        },
        {
          text: "Is Paid",
          value: "isPaid"
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          align: "end"
        }
      ],
      isHideFinalized: false,
      dialog: false,
      editedItem: {},
      childInfo: {},
      schoolYearSelected: {},
      subjectId: "1",
      gradeLevel: "0"
    };
  },
  methods: {
    ...mapActions([
      "getSchoolYearsAction",
      "getExamsAction",
      "logout",
      "updateExamRegistrationMarksAction",
      "setSchoolYearAction"
    ]),

    async loadSchoolYears() {
      try {
        await this.getSchoolYearsAction();
        if (this.$store.state.schoolYears == null) {
          this.logout();
          console.log("im logged out");
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    },

    async loadExams(schoolYearId, isHideFinalized, subjectId, gradeLevel, search) {
      if (!schoolYearId) {
        return;
      }
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      console.log("this.options", this.options);
      console.log("sortBy, sortDesc", sortBy, sortDesc);
      console.log("page, itemsPerPage", page, itemsPerPage);

      let sortExpression = "";
      var i;
      for (i = 0; i < sortBy.length; i++) {
        if (sortExpression !== "") {
          sortExpression = sortExpression + ",";
        }
        sortExpression = sortExpression + sortBy[i];
        if (sortDesc[i]) {
          sortExpression = sortExpression + " desc";
        }
      }
      if (sortExpression === "") {
        sortExpression = "id";
      }
      console.log("sortExp", sortExpression);

      try {
        await this.getExamsAction({
          id: schoolYearId,
          isHideFinalized: isHideFinalized,
          subjectId: subjectId,
          gradeLevel: gradeLevel,
          token: this.$store.state.token,
          page: page,
          itemsPerPage: itemsPerPage,
          sortBy: sortExpression,
          search: search
        });
        if (this.$store.state.exams == null) {
          this.logout();
          console.log("im logged out");
          this.$router.go();
        }
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
      this.loading = false;
    },

    async save() {
      try {
        const model = this.createExamRegistrationPatchModel();
        console.log("themodel", model);
        await this.updateExamRegistrationMarksAction({
          model: model,
          token: this.$store.state.token
        });
        this.close();
      } catch (err) {
        this.$store.state.error = this.errorMessage(err);
        this.$store.state.snackbar = true;
        console.log(err);
      }
    }
  }
};
</script>
